import { GET_ALL_NOTIFICATION, GET_UNREAD_NOTIFICATION } from "./actions";

const initialState = {
  notificationList: {
    docs: [],
    totalDocs: 0,
    limit: 10,
    page: 1,
    totalPages: 0,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: null,
    nextPage: null,
  },
  notificationData: 0,
  notificationLoading: true,
};

const notificationReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_ALL_NOTIFICATION:
      return {
        ...state,
        notificationList: payload,
        notificationLoading: false,
      };
    case GET_UNREAD_NOTIFICATION:
      return {
        ...state,
        notificationData: payload,
        notificationLoading: false,
      };
    default:
      return state;
  }
};
export default notificationReducer;
